<script setup lang="ts">
defineProps<{ label?: string }>()
</script>

<template>
    <!-- TODO : Switch back to b-menu-list when fix is released -->
    <ul :label="label ? $t(label) : undefined" class="menu-list" v-bind="$attrs">
        {{
            label ? $t(label) : undefined
        }}
        <slot />
    </ul>
</template>

<style>
.menu-list li ul {
    margin-right: 0;
    padding-left: 0;
    border-left: none;
}
</style>
